import { defaultLabels } from '../../shared/questionDefaults';
import type { Field, FieldType } from '../../shared/types';
import { acknowledgmentLabel, DEFAULT_ACKNOWLEDGMENT_LABEL } from '../../shared/answers';
import { validationKinds, validationEnabled } from '../../shared/questionSettings';
import { ensureQuestionIds, newQuestionItemId } from '../../shared/questionIds';

/** Keep the question's identity, wording, and settings when changing its response type. */
export function changeFieldType(field: Field, type: FieldType): Field {
  const next = { ...field, type };
  if (validationEnabled(field) && field.validation && !validationKinds(type).includes(field.validation.kind)) next.validationEnabled = false;
  if (next.routing?.enabled && type !== 'choice' && type !== 'dropdown') next.routing = { ...next.routing, enabled: false };
  // Checkboxes, and a grid of them, may be left unchecked, so a question becoming one stops being required until the
  // organizer says so; an acknowledgment becoming checkboxes keeps its single box required, below.
  if ((type === 'checkboxes' || type === 'checkbox_grid') && field.type !== type) next.required = false;
  if (field.type === 'acknowledgment' && type === 'checkboxes') {
    next.options = [acknowledgmentLabel(field)]; next.optionIds = [newQuestionItemId()]; next.allowOther = false; next.required = true;
    next.validationEnabled = true; next.validation = { kind: 'selection', op: 'exact', value: '1' };
  }
  if (type === 'acknowledgment') { next.required = true; next.acknowledgmentLabel ??= DEFAULT_ACKNOWLEDGMENT_LABEL; }
  if (type === 'section' || type === 'title_text') next.required = false;
  if (['choice', 'checkboxes', 'dropdown'].includes(type)) next.options = defaultLabels(next.options, 'Option');
  if (type === 'linear_scale') next.scale ??= { min: 1, max: 5 };
  if (type === 'choice_grid' || type === 'checkbox_grid') next.grid ??= { rows: [''], columns: [''] };
  if (type === 'rating') next.rating ??= { max: 5 };
  return ensureQuestionIds(next);
}
export function newQuestion(): Field {
  // New questions are required; the organizer turns that off for one that can be skipped.
  return changeFieldType({ id: crypto.randomUUID().slice(0, 8), type: 'choice', label: '', required: true }, 'choice');
}
/** A plain Return in an option, row or column, which starts the next one. Not while an input method is composing text. */
export function startsNext(event: KeyboardEvent): boolean {
  return event.key === 'Enter' && !event.isComposing && !event.shiftKey && !event.altKey && !event.ctrlKey && !event.metaKey;
}
